import React, { useMemo } from "react"

import { InstantSearch } from "react-instantsearch"

import { getSearchClient } from "@/utils/typesense-config"
import { useI18next } from "@zestia/gatsby-plugin-react-i18next"

const SupportSearchProvider = ({
  indexName,
  useQueryParams = false,
  children,
}) => {
  const { language } = useI18next()

  const searchClient = useMemo(() => getSearchClient(language), [language])

  return (
    <InstantSearch
      indexName={indexName}
      searchClient={searchClient}
      future={{
        preserveSharedStateOnUnmount: true,
      }}
      routing={useQueryParams}
    >
      {children}
    </InstantSearch>
  )
}

export default SupportSearchProvider
